/* eslint-disable jsx-a11y/anchor-is-valid */

import { Col, Dropdown, Row, Select } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import Images from 'app/assets/img';
import { ReactComponent as LogoutIcon } from 'app/assets/img/logout.svg';
import { ReactComponent as MenuIcon } from 'app/assets/img/menu-icon.svg';
import { Permission } from 'app/hooks/usePermission';
import useWindowSize from 'app/hooks/useWindowSize';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { appActions } from 'app/pages/App/slice';
import {
  selectInfoUser,
  selectIsLoading,
  selectIsLogged,
  selectLayoutFooter,
  selectMaintenance,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { selectLengthCart } from 'app/pages/Cart/slice/selectors';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { BP_TYPE } from 'utils/constants';
import { getCookie, setCookie } from 'utils/cookies';
import { onFuncCheckShowDialogLogin } from 'utils/helper';
import { UTC_OFFSET } from 'utils/hooks/useCountDown';
import RenderIf from '../RenderIf';
import Cart, { NeedToPayment } from './Cart';
import ContainerFluid from './ContainerFluid';
import { useHasComboHolidayAccess } from 'app/pages/HomePage/hooks/useHasComboHolidayAccess';

export type HeaderRef = {
  setSteps: (step: 1 | 2 | 3) => void;
  setShowStep: (show: boolean) => void;
};

const LoginView = () => {
  const history = useHistory();
  const { device } = useWindowSize();
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const cartLength = useSelector(selectLengthCart);
  const { onLogout, onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const [menuVisible, setMenuVisible] = useState(false);
  const [agentMenuVisible, setAgentMenuVisible] = useState(false);
  const { locale, onChangeLanguage } = useGlobalFunction();
  const onGoToProfile = () => {
    onFuncCheckShowDialogLogin().then(() => {
      history.push('/account');
    });
  };
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;
  const onGoToAgentProfile = () => {
    if (!isSaleMng) return;
    onFuncCheckShowDialogLogin().then(() => {
      history.push('/agent/profile');
    });
  };
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const { pathname } = useLocation();
  const footer = useSelector(selectLayoutFooter);
  const renderMessCofirmLogout = (message: string) => {
    const partsOfMsg = message.split('\\n\\r');
    return partsOfMsg.map(i => <LogoutConfirmMsg>{i}</LogoutConfirmMsg>);
  };
  const onConfirmLogout = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2c.menu.logout'] ?? '',
      content: renderMessCofirmLogout(
        translations?.['b2c.text.logoutConfirm'] ?? '',
      ),
      buttons: [
        {
          text: translations?.['b2c.btn.cancel'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2c.txt.confirm'] ?? '',
          bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
          color: 'white',
          onClick: () => {
            onCloseDialogNoti();
            onLogout();
          },
        },
      ],
      maskClosable: false,
      icon: <LogoutIcon />,
      onCloseDialog: onCloseDialogNoti,
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <RenderIf
          condition={device === 'desktop'}
          fallback={
            <Row gutter={device === 'mobile' ? 16 : 24}>
              {isSaleMng && (
                <Col
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Dropdown
                    visible={agentMenuVisible}
                    placement="bottom"
                    trigger={['click']}
                    onVisibleChange={visible => setAgentMenuVisible(visible)}
                    getPopupContainer={trigger =>
                      trigger.parentNode as HTMLElement
                    }
                    overlay={
                      <div
                        style={{
                          padding: '16px',
                          backgroundColor: 'white',
                          marginTop: 16,
                          borderRadius: 8,
                          boxShadow: '0px 20px 20px 0px #0000000D',
                        }}
                      >
                        <Link to="/agent/profile">
                          <StyledAccountMenuItem
                            onClick={() => setAgentMenuVisible(false)}
                            isSelected={pathname === '/agent/profile'}
                          >
                            <img src={Images.StoreIcon} alt="" />
                            {translations?.['b2b.menu.agent-profile'] ?? ''}
                          </StyledAccountMenuItem>
                        </Link>
                        <Link to="/agent/list-account">
                          <StyledAccountMenuItem
                            onClick={() => setAgentMenuVisible(false)}
                            isSelected={pathname === '/agent/list-account'}
                          >
                            <img src={Images.UserIcon} alt="" />
                            {translations?.['b2b.menu.agent-list-account'] ??
                              ''}
                          </StyledAccountMenuItem>
                        </Link>
                        {!isProxyBuyer && (
                          <Link to="/agent/transaction-history">
                            <StyledAccountMenuItem
                              onClick={() => setAgentMenuVisible(false)}
                              isSelected={
                                pathname === '/agent/transaction-history'
                              }
                            >
                              <img src={Images.HistoryIcon} alt="" />
                              {
                                translations?.[
                                  'b2b.menu.agent-transaction-history'
                                ]
                              }
                            </StyledAccountMenuItem>
                          </Link>
                        )}
                      </div>
                    }
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: 14,
                        cursor: 'pointer',
                      }}
                    >
                      <img src={Images.StoreIcon} alt="" />
                    </div>
                  </Dropdown>
                </Col>
              )}
              <Col
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Dropdown
                  visible={menuVisible}
                  trigger={['click']}
                  onVisibleChange={visible => setMenuVisible(visible)}
                  getPopupContainer={trigger =>
                    trigger.parentNode as HTMLElement
                  }
                  placement="bottom"
                  overlay={
                    <div
                      style={{
                        padding: '16px',
                        backgroundColor: 'white',
                        marginTop: 16,
                        borderRadius: 8,
                        boxShadow: '0px 20px 20px 0px #0000000D',
                      }}
                    >
                      <Link to="/account">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname.includes('/account')}
                        >
                          <img src={Images.HistoryIcon} alt="" />
                          {translations?.['b2c.txt.order-history'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link>
                      <RenderIf condition={isSaleMng && !isProxyBuyer}>
                        <Link to="/approve-order">
                          <StyledAccountMenuItem
                            onClick={() => setMenuVisible(false)}
                            isSelected={pathname.includes('/approve-order')}
                          >
                            <img src={Images.CheckTicketIcon} alt="" />
                            {translations?.['b2b.txt.approveOrder'] ?? ''}
                          </StyledAccountMenuItem>
                        </Link>
                      </RenderIf>
                      <Link to="/order-management">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname.includes('/order-management')}
                        >
                          <img src={Images.AutoDeposit} alt="" />
                          {translations?.['b2b.orderManager'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link>
                      <Link to="/check-tickets">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname.includes('/check-tickets')}
                        >
                          <img src={Images.CheckTicketIcon} alt="" />
                          {translations?.['b2b.txt.check-ticket'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link>
                      {/* <Link to="/restaurant/booking-slots">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname.includes(
                            '/restaurant/booking-slots',
                          )}
                        >
                          <img src={Images.CheckTicketIcon} alt="" />
                          {translations?.['b2b.txt.bookingLookup'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link> */}
                      <Link to="/files-management">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname.includes('/files-management')}
                        >
                          <img src={Images.DocumentIcon} alt="" />
                          {translations?.['b2b.account.files-management'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link>
                      <Link to="/profile">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname === '/profile'}
                        >
                          <img src={Images.UserIcon} alt="" />
                          {translations?.['b2c.menu.account'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link>
                      <RenderIf
                        condition={
                          infoUser?.role_code ===
                            Permission.ROLE_SALE_MANAGER &&
                          !isProxyBuyer &&
                          !!infoUser.businessPartner?.bankInfo?.tid
                        }
                      >
                        <Link to="/auto-deposit">
                          <StyledAccountMenuItem
                            onClick={() => setMenuVisible(false)}
                            isSelected={pathname === '/auto-deposit'}
                          >
                            <img
                              src={Images.AutoDeposit}
                              alt="TopUpDeposit"
                              style={{
                                transform: 'translateX(-3px)',
                                marginRight: 3,
                              }}
                            />
                            {translations?.['b2b.autoDeposit'] ?? ''}
                          </StyledAccountMenuItem>
                        </Link>
                      </RenderIf>
                      {/* <Link to="/payment-guide">
                        <StyledAccountMenuItem
                          onClick={() => setMenuVisible(false)}
                          isSelected={pathname === '/payment-guide'}
                        >
                          <img src={Images.AccountPaymentGuideIcon} alt="" />
                          {translations?.['b2b.txt.manualDeposit'] ?? ''}
                        </StyledAccountMenuItem>
                      </Link> */}
                      <StyledAccountMenuItem
                        onClick={() => {
                          onConfirmLogout();
                          setMenuVisible(false);
                        }}
                        isSelected={false}
                      >
                        <img src={Images.LogoutIcon} alt="" />
                        {translations?.['b2c.menu.logout'] ?? ''}
                      </StyledAccountMenuItem>
                    </div>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: 14,
                      cursor: 'pointer',
                    }}
                  >
                    <img src={Images.UserProfile} alt="" />
                  </div>
                </Dropdown>
              </Col>
              <Col
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Cart />
              </Col>
            </Row>
          }
        >
          <Row gutter={24} align="middle">
            <Col>
              <Cart />
            </Col>
            <Col>
              <Row gutter={16}>
                <Col
                  onClick={onGoToAgentProfile}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 14,
                    cursor: isSaleMng ? 'pointer' : 'context-menu',
                  }}
                >
                  <TooltipParagraph
                    style={{
                      maxWidth: 140,
                      margin: 0,
                    }}
                    ellipsis={{ rows: 1 }}
                    placement="bottom"
                  >
                    {infoUser?.businessPartner?.name ?? ''}
                  </TooltipParagraph>
                  <img
                    style={{ marginLeft: 4 }}
                    src={Images.StoreIcon}
                    alt=""
                  />
                </Col>
                <Col
                  onClick={onGoToProfile}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 14,
                    cursor: 'pointer',
                  }}
                >
                  <TooltipParagraph
                    style={{
                      maxWidth: 140,
                      margin: 0,
                    }}
                    ellipsis={{ rows: 1 }}
                    placement="bottom"
                  >
                    {infoUser?.name ?? ''}
                  </TooltipParagraph>
                  <img
                    style={{ marginLeft: 4 }}
                    src={Images.AvatarIcon}
                    alt=""
                  />
                </Col>
              </Row>
            </Col>
            <RenderIf condition={device === 'desktop'}>
              <Col>
                <StyledSelect
                  bordered={false}
                  value={locale}
                  getPopupContainer={trigger =>
                    trigger.parentNode as HTMLElement
                  }
                  onChange={value => {
                    if (value) onChangeLanguage(value as 'vi' | 'en');
                  }}
                  optionLabelProp="label"
                  dropdownStyle={{
                    zIndex: 5,
                  }}
                  options={['vi', 'en'].map(val => ({
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={val === 'vi' ? Images.FlagVN : Images.FlagUK}
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: 20,
                            marginRight: 8,
                            overflow: 'hidden',
                          }}
                          alt=""
                        />
                        <div>{val === 'vi' ? 'VIE' : 'ENG'}</div>
                      </div>
                    ),
                    value: val,
                  }))}
                ></StyledSelect>
              </Col>
            </RenderIf>
          </Row>
        </RenderIf>
      </div>
      <RenderIf condition={cartLength > 0 && device === 'desktop'}>
        <NeedToPayment style={{ position: 'absolute', right: 16, bottom: 8 }} />
      </RenderIf>
    </div>
  );
};

const NewHeader = forwardRef<
  HeaderRef,
  { setIsShowDrawer: (show: boolean) => void; isDisplayLayout: boolean }
>(({ setIsShowDrawer, isDisplayLayout }, ref) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const { locale, onChangeLanguage } = useGlobalFunction();
  const footer = useSelector(selectLayoutFooter);

  const [menuVisible, setMenuVisible] = useState(false);
  const { device } = useWindowSize();

  const isLogged = useSelector(selectIsLogged);
  const infoUser = useSelector(selectInfoUser);
  const isLoading = useSelector(selectIsLoading);
  const headerBlock = useRef<HTMLHeadElement>(null);

  const { data: maintenanceData } = useSelector(selectMaintenance);

  const onGoToHome = () => {
    const allowBuyShortTerm = !!infoUser?.businessPartner?.allowBuyShortTerm;
    const bpLongTerm = String(infoUser?.businessPartner?.bpLongTerm) === '01';

    let ticketType: any;

    if (allowBuyShortTerm && bpLongTerm) {
      ticketType = 0;
    } else if (bpLongTerm) {
      ticketType = 1;
    } else {
      ticketType = 0;
    }

    sessionStorage.setItem('ticketType', JSON.stringify(ticketType));
    history.push('/');
  };

  useEffect(() => {
    const getHeaderDOMRect = () => {
      if (headerBlock.current) {
        const headerDOMRect = headerBlock.current.getBoundingClientRect();
        dispatch(appActions.setHeaderDOMRect(headerDOMRect));
      }
    };

    getHeaderDOMRect();
    window.addEventListener('resize', getHeaderDOMRect);

    return () => {
      window.removeEventListener('resize', getHeaderDOMRect);
    };
  }, [dispatch]);

  const [showTimeZone, setShowTimeZone] = useState(false);

  useEffect(() => {
    const isShowDialogWarningTimeZoneFirstTime = getCookie(
      'isShowDialogWarningTimeZoneFirstTime',
    );

    const offsetMinutes = -new Date().getTimezoneOffset();
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(
      2,
      '0',
    );
    const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');

    const timezoneOffset = `${sign}${hours}:${minutes}`;
    console.log(timezoneOffset); // Ví dụ: "+07:00"

    if (isShowDialogWarningTimeZoneFirstTime !== 'true') {
      if (timezoneOffset !== UTC_OFFSET) {
        setShowTimeZone(true);
        setCookie('isShowDialogWarningTimeZoneFirstTime', 'true');
      } else {
        setCookie('isShowDialogWarningTimeZoneFirstTime', 'false');
      }
    }
  }, []);
  const { isHasComboHolidayAccess } = useHasComboHolidayAccess();
  return (
    <Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: '#F8F8F8',
        display: isDisplayLayout ? 'block' : 'none',
        height: 'auto',
        padding: 0,
        lineHeight: 'normal',
      }}
      ref={headerBlock}
    >
      <DialogWarning
        maskClosable={false}
        open={showTimeZone}
        onClose={() => setShowTimeZone(false)}
        message={
          translations?.['b2b.txt.warningTimeZone'] ??
          'Hệ thống đang thực hiện trên timezone UTC +7, các ghi nhận về thời gian sẽ theo timezone này'
        }
      />
      <ContainerFluid
        style={{
          height: device === 'desktop' ? 120 : 76,
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <RenderIf
            condition={device === 'desktop'}
            fallback={
              <div
                onClick={() => {
                  setIsShowDrawer(true);
                }}
                style={{ cursor: 'pointer' }}
              >
                <MenuIcon />
              </div>
            }
          >
            <></>
          </RenderIf>
          <div
            onClick={onGoToHome}
            style={{
              cursor: 'pointer',
              marginLeft:
                device === 'desktop'
                  ? maintenanceData?.isMaintain
                    ? 0
                    : 0
                  : 24,
            }}
          >
            <img src={Images.SunImg} alt="" width={153} height={37} />
          </div>
        </div>
        <RenderIf
          condition={
            !maintenanceData?.isMaintain && device === 'desktop' && !!infoUser
          }
        >
          <div className="d-flex gap-3">
            {translations && (
              <>
                <ButtonMenu
                  onClick={() =>
                    history.location.pathname !== '/catalog'
                      ? history.push('/catalog')
                      : {}
                  }
                  isActive={history.location.pathname === '/catalog'}
                >
                  {translations['b2b.txt.parkTicket']}
                </ButtonMenu>
                <ButtonMenu
                  onClick={() =>
                    history.location.pathname !== '/booking-mask'
                      ? history.push('/booking-mask')
                      : {}
                  }
                  isActive={
                    history.location.pathname === '/booking-mask' ||
                    history.location.pathname.startsWith('/holiday')
                  }
                  hidden={!isHasComboHolidayAccess}
                >
                  {translations['b2b.txt.holidayComboTicket']}
                </ButtonMenu>
                <ButtonMenu
                  onClick={() =>
                    history.location.pathname !== '/restaurants'
                      ? history.push('/restaurants')
                      : {}
                  }
                  isActive={history.location.pathname === '/restaurants'}
                >
                  {translations['b2b.txt.restaurant'] ?? 'Nhà hàng'}
                </ButtonMenu>
              </>
            )}
          </div>
        </RenderIf>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <RenderIf
            condition={!!maintenanceData?.isMaintain && device === 'desktop'}
            fallback={
              <>
                {!(isLoading && !infoUser
                  ? null
                  : !isLogged || !infoUser || maintenanceData?.isMaintain) && (
                  <LoginView />
                )}
              </>
            }
          >
            <div className="d-flex align-items-center">
              <StyledSelect
                bordered={false}
                value={locale}
                getPopupContainer={trigger => trigger.parentNode as HTMLElement}
                onChange={value => {
                  if (value) onChangeLanguage(value as 'vi' | 'en');
                }}
                optionLabelProp="label"
                dropdownStyle={{
                  zIndex: 5,
                }}
                options={['vi', 'en'].map(val => ({
                  label: (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={val === 'vi' ? Images.FlagVN : Images.FlagUK}
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 20,
                          marginRight: 8,
                          overflow: 'hidden',
                        }}
                        alt=""
                      />
                      <div>{val === 'vi' ? 'VIE' : 'ENG'}</div>
                    </div>
                  ),
                  value: val,
                }))}
              />
            </div>
          </RenderIf>
        </div>
      </ContainerFluid>
    </Header>
  );
});

export default NewHeader;

export const StyledSelect = styled(Select)`
  .ant-select-dropdown {
    width: 300px;
  }
  .ant-select-selector {
    padding-left: 0 !important;
  }
`;

const Hotline = styled.p`
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  margin-right: 6px;
  span {
    font-weight: 700;
    color: #e92127;
  }
`;

const StyledAccountMenuItem = styled.div<{
  isSelected: boolean;
}>`
  width: max-content;
  color: #000000;
  background-color: ${props =>
    props.isSelected ? '#FFEDEB80' : 'transparent'};
  border-radius: 20px;
  padding: 12px 16px 12px 16px;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  img {
    margin-right: 8px;
  }
`;

const LogoutConfirmMsg = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #1c1b1f;
  text-align: center;
  margin: 0 auto;
  &:not(:first-child) {
    margin-top: 1px;
  }
`;
const ButtonMenu = styled.button<{ isActive?: boolean }>`
  font-size: 14px;
  border-radius: 6px;
  padding: 8px 16px;
  transition: var(--transition-regular);
  border: ${props => (props.isActive ? 'none' : '1px solid var(--color-9)')};
  background: ${props =>
    props.isActive ? 'var(--color-gradient)' : 'transparent'};
  color: ${props => (props.isActive ? 'var(--color-13)' : 'var(--color-9)')};
  &:hover {
    background: var(--color-gradient);
    color: var(--color-13);
  }
`;
